import styled from '@emotion/styled';
import { Modal, Typography } from '@ui-components/neo.tax';

export const StyledModal = styled(Modal)({
  width: 400,
});

export const StyledTypographyBlock = styled(Typography)({
  display: 'block',
});

export const StyledTypography = styled(Typography)({
  outline: 'none',
});
